import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import React from "react";

import ConditionalComponent from "../../Shared/ConditionalComponent";
import {AiChatModal} from "./AiChat";

export const ConditionalChatComponent = observer(({}) => {
    const {generalStore, aiStore} = useStores();
    return (
        <ConditionalComponent if={generalStore?.domainSettings?.IsSupportAIChatWebEnabled && generalStore?.userDetails?.Name}>
            <AiChatModal/>
        </ConditionalComponent>
    )
});